<section [@fadeInDown]>
  <div class="base-container">
    <div class="row">
      <app-back-button></app-back-button>
    </div>
    <app-forgot-password-form></app-forgot-password-form>
  </div>
</section>
